import * as React from 'react';

const SVGCheck: React.SFC<SvgProps> = props => (
    <svg width={16} height={13} {...props}>
        <path
            d="M1.421 7.181a.6.6 0 00-.842.855l4.629 4.561a.6.6 0 00.889-.051l8.99-11.17a.6.6 0 10-.935-.752L5.578 11.277 1.42 7.18z"
            fill="currentColor"
            fillRule="nonzero"
        />
    </svg>
);

export default SVGCheck;
